import API from "../authentication/AuthInterceptor";

export class BillingService {
  async getInvoices() {
    const response = await API.get("/distributor/invoices");
    return response.data.body.invoices;
  }
}
